import { render, staticRenderFns } from "./createTemplateData.vue?vue&type=template&id=da66d542&scoped=true"
import script from "./createTemplateData.vue?vue&type=script&lang=js"
export * from "./createTemplateData.vue?vue&type=script&lang=js"
import style0 from "./createTemplateData.vue?vue&type=style&index=0&id=da66d542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da66d542",
  null
  
)

export default component.exports